import { FC } from "react";
import { ItemListAsyncCollectionRow } from "./variants/item-list-async-collection-row";
import { ItemListAsyncNoteRow } from "./variants/item-list-async-note-row";
import { ItemListAsyncTemplateRow } from "./variants/item-list-async-template-row";
import { ItemListAsyncSessionRow } from "./variants/item-list-async-session-row";
import { ItemListAsyncCalendarEventRow } from "./variants/item-list-async-calendar-event-row";
import { ItemListCarouselRow } from "./variants/item-list-carousel-row";
import { ItemListItemRow } from "./variants/item-list-item-row";
import { ItemListOtherRow } from "./variants/item-list-other-row";
import { ItemListSectionHeaderRow } from "./variants/item-list-section-header-row";
import { ItemListCollapsibleSectionHeaderRow } from "./variants/item-list-collapsible-section-header-row";
import { ItemListSkeletonRow } from "./variants/item-list-skeleton-row";
import { ItemListRowData, ItemListRowType } from "../types";

interface ItemListRowRendererProps {
  index: number;
  data: ItemListRowData;
}

export const ItemListRowRenderer: FC<ItemListRowRendererProps> = ({ data }) => {
  switch (data.type) {
    case ItemListRowType.Skeleton:
      return <ItemListSkeletonRow data={data} />;
    case ItemListRowType.Carousel:
      return <ItemListCarouselRow data={data} />;
    case ItemListRowType.Item:
      return <ItemListItemRow data={data} />;
    case ItemListRowType.SectionHeader:
      return <ItemListSectionHeaderRow data={data} />;
    case ItemListRowType.CollapsibleSectionHeader:
      return <ItemListCollapsibleSectionHeaderRow data={data} />;
    case ItemListRowType.Padding:
      return <div style={{ height: data.payload.height }} />;
    case ItemListRowType.AsyncNote:
      return <ItemListAsyncNoteRow data={data} />;
    case ItemListRowType.AsyncCollection:
      return <ItemListAsyncCollectionRow data={data} />;
    case ItemListRowType.Other:
      return <ItemListOtherRow data={data} />;
    case ItemListRowType.AsyncTemplate:
      return <ItemListAsyncTemplateRow data={data} />;
    case ItemListRowType.AsyncSession:
      return <ItemListAsyncSessionRow data={data} />;
    case ItemListRowType.AsyncCalendarEvent:
      return <ItemListAsyncCalendarEventRow data={data} />;
    default:
      throw new Error("Unknown slice type");
  }
};
